import React, { useState } from "react";
import { useEffect } from "react";
import { Button, Col, Form, Input, InputGroup, Row } from "reactstrap";

const SearchTerm = ({ setSearch }) => {
  const [term, setTerm] = useState("");
  const [searchButtonDisabled, setSearchButtonDisabled] = useState(true);

  const setTextSearch = (value) => {
    setTerm(value);
  };

  useEffect(() => {
    setSearchButtonDisabled(!term.length>0);
  }, [term]);

  const executeSearch = () => {
    setSearch({term});
  };

  
  const renderFields = () => {
    
      return (

          <Form className="d-flex w-100" onSubmit={(e) => {
            e.preventDefault()
            executeSearch()}}>
            <Col className="my-2">
              <div className="d-flex justify-content-start">
                <InputGroup>
                  <Input type="text" className="form-control" placeholder="Buscar por..." value={term} onChange={(e) => setTextSearch(e.target.value)} />
                  <div className="input-group-append">
                  <Button type="submit" color="info" 
                    // onClick={() => executeSearch()} 
                    disabled={searchButtonDisabled}>
                    <i className="fas fa-search"></i> Buscar
                  </Button>
                  </div>
                </InputGroup>
              </div>
            </Col>
          </Form>
      );
    
  };

  return <Row>{renderFields()}</Row>;
};

export default SearchTerm;
